import { render, staticRenderFns } from "./MyAssessment.vue?vue&type=template&id=fe8a1cd0&scoped=true"
import script from "./MyAssessment.vue?vue&type=script&lang=js"
export * from "./MyAssessment.vue?vue&type=script&lang=js"
import style0 from "./MyAssessment.vue?vue&type=style&index=0&id=fe8a1cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8a1cd0",
  null
  
)

export default component.exports